import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useLookups, useSearch } from "@/lib/lookups";
import { LookupBox } from "./LookupBox";

/** Company look-up (Connexis search): a name or number in, the company's details out. onPick returns how many fields it filled. */
export function CompanyLookup({ onPick, testId = "company-lookup", className, dark = false, label = "Find the company" }) {
  const { company, company_source: source } = useLookups();
  const [q, setQ] = useState("");
  const [picked, setPicked] = useState(null);
  const { items, busy, error } = useSearch(company ? "/lookup/companies" : null, q === picked ? "" : q, source === "connexis" ? 3 : 2);
  const [loading, setLoading] = useState(false);
  if (!company) return null;
  const from = "Connexis search";

  const pick = async (it) => {
    setLoading(true);
    try {
      const r = await api.get(`/lookup/companies/${encodeURIComponent(it.company_number)}`);
      const name = r.data.business_name || it.title;
      setPicked(name);
      setQ(name);
      const n = onPick(r.data);
      if (n === 0) toast("Nothing to fill — every field already had something in it");
      else toast.success(n ? `Filled ${n} empty field${n === 1 ? "" : "s"} from ${from} — anything you'd typed is kept` : `Filled in from ${from} — check it over`);
    } catch (e) {
      toast.error(e?.response?.status < 500 || e?.response?.status === 503 ? e.response.data?.detail : "We couldn't bring the details up this time — carry on typing them in.");
    } finally { setLoading(false); }
  };

  return (
    <LookupBox label={label} note="Connexis Search fills the gaps for you" placeholder="Company name or number, e.g. 01234567"
               value={q} onChange={setQ} items={items} busy={busy || loading} error={error} onPick={pick}
               testId={testId} className={className} dark={dark}
               waitText="Bear with us while we bring up the details (up to 15 seconds) — or carry on typing them in."
               render={(it) => (
                 <>
                   <b>{it.title}</b>
                   <small>{it.company_number}{it.status ? ` · ${it.status}` : ""}{it.address ? ` · ${it.address}` : ""}</small>
                 </>
               )} />
  );
}
